@if (rows.length) {
  <button type="button" class="citation-overflow-trigger" [matMenuTriggerFor]="overflowMenu">+{{ rows.length }}</button>
}
<mat-menu #overflowMenu="matMenu" class="citation-overflow-menu">
  <span class="overflow-title">{{ '{{count}} more sources' | translate: { count: rows.length } }}</span>
  @for (row of rows; track trackByIndex($index)) {
    <a mat-menu-item class="overflow-row" [href]="row.marker.citation.route" [matTooltip]="row.fullLabel"
      (click)="onRowClick($event, row.marker.citation)">
      <span class="overflow-number">{{ row.marker.index }}</span>
      @if (row.typeLabel) {
        <span class="overflow-type">{{ row.typeLabel | translate }}</span>
      }
      <span class="overflow-label">{{ row.label }}</span>
    </a>
  }
</mat-menu>
